export default "__VITE_ASSET__DJoN0uw5__"